module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNpi5GlwYCAFMDGQCOivQU5AYnl4s56ECrEabBUMfDRstsX349LDzOaggMy//OKOvICEqYxWiI7TnrunX355R0ADEGy5eRSuZ83V/R9/fKF2KM3wL4828AAa7LWw8NGHFwQ0AJXCVV96cYewp4FKgR7I3NiJVTUQMA6DtAQQYAB3gzObNBFUdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right2.png
// module id = 622
// module chunks = 1 6